import { render, staticRenderFns } from "./SectionVision.vue?vue&type=template&id=824dcb78&"
import script from "./SectionVision.vue?vue&type=script&lang=js&"
export * from "./SectionVision.vue?vue&type=script&lang=js&"
import style0 from "./SectionVision.vue?vue&type=style&index=0&id=824dcb78&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomTitle: require('/app/components/atoms/common/AtomTitle.vue').default,OrganismsCommonOrganismTitleAndDescription: require('/app/components/organisms/common/OrganismTitleAndDescription.vue').default})
